<svg
  [style.width.px]="width()"
  [style.height.px]="height()"
  [style.fill]="color()"
>
  <use [attr.href]="path() + '#icon'" />
</svg>
